<h1 mat-dialog-title>New Bookmark Limit Reached</h1>

<div mat-dialog-content class="pt-1 pb-6">
  <div class="text-14 pb-3">
    You've reached your limit of 5 3D models in your Library. You can make changes to this model,
    but you will not be able to save as a new model.
  </div>
  <div class="text-14">Upgrade to a Premium Plan to save unlimited 3D models.</div>
</div>

<div mat-dialog-actions class="pt-2">
  <button app-button buttonTheme="light" [mat-dialog-close]="false" cdkFocusInitial class="mr-2">
    OK
  </button>
  <button app-button buttonType="primary" [mat-dialog-close]="true">Upgrade Now</button>
</div>
